var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _path9, _path0, _g3, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderTablesEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 314,
    viewBox: "0 0 392 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.571 313.299C288.517 313.299 354.473 247.618 354.473 166.946C354.2 86.0024 288.517 20.3207 207.571 20.3207C126.352 20.3207 60.6687 86.0024 60.6687 166.674C60.6687 247.618 126.352 313.299 207.571 313.299Z",
    fill: "#F3F1FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358.016 115.709C364.187 115.709 369.19 110.706 369.19 104.535C369.19 98.3639 364.187 93.3611 358.016 93.3611C351.845 93.3611 346.842 98.3639 346.842 104.535C346.842 110.706 351.845 115.709 358.016 115.709Z",
    fill: "#F3F1FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M374.369 72.103C378.583 72.103 382 68.6865 382 64.472C382 60.2574 378.583 56.8409 374.369 56.8409C370.154 56.8409 366.738 60.2574 366.738 64.472C366.738 68.6865 370.154 72.103 374.369 72.103Z",
    fill: "#F3F1FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1316 265.06C55.9588 265.06 62.304 258.715 62.304 250.888C62.304 243.061 55.9588 236.716 48.1316 236.716C40.3044 236.716 33.9592 243.061 33.9592 250.888C33.9592 258.715 40.3044 265.06 48.1316 265.06Z",
    fill: "#F3F1FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1606_51365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.453 204.31C161.453 216.982 151.205 227.229 138.423 227.229C138.202 227.229 136.329 227.229 122.555 227.229C112.968 227.229 97.6512 227.229 73.1882 227.229H61.5076C46.1907 227.56 33.9592 215.329 33.9592 200.563C33.9592 185.687 46.3009 173.346 61.8382 174.117C75.1717 132.465 136.219 138.306 141.398 181.39C152.858 182.823 161.453 192.519 161.453 204.31Z",
    fill: "url(#paint0_linear_1606_51365)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.423 227.229C151.095 227.229 161.453 216.982 161.453 204.31C161.453 191.638 151.095 181.39 138.423 181.39C125.751 181.39 115.392 191.638 115.392 204.31C115.392 216.982 125.751 227.229 138.423 227.229Z",
    fill: "url(#paint1_linear_1606_51365)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.847 227.45C123.437 227.45 141.839 209.158 141.839 186.569C141.839 163.98 123.437 145.688 100.847 145.688C78.2571 145.688 59.8547 163.98 59.8547 186.569C59.8547 209.158 78.1469 227.45 100.847 227.45Z",
    fill: "url(#paint2_linear_1606_51365)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1606_51365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.883 91.9625C197.883 109.444 183.746 123.581 166.112 123.581C165.808 123.581 163.223 123.581 144.221 123.581C130.996 123.581 109.866 123.581 76.1179 123.581H60.0041C38.8738 124.037 22 107.164 22 86.7941C22 66.2724 39.0259 49.247 60.4602 50.3111C78.8542 -7.14955 163.071 0.907097 170.216 60.3439C186.026 62.3201 197.883 75.6972 197.883 91.9625Z",
    fill: "url(#paint3_linear_1606_51365)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.112 123.581C183.594 123.581 197.883 109.444 197.883 91.9626C197.883 74.4812 183.594 60.344 166.112 60.344C148.63 60.344 134.34 74.4812 134.34 91.9626C134.34 109.444 148.63 123.581 166.112 123.581Z",
    fill: "url(#paint4_linear_1606_51365)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.274 123.885C145.437 123.885 170.824 98.651 170.824 67.4885C170.824 36.3259 145.437 11.0919 114.274 11.0919C83.1106 11.0919 57.7239 36.3259 57.7239 67.4885C57.7239 98.651 82.9586 123.885 114.274 123.885Z",
    fill: "url(#paint5_linear_1606_51365)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.757 139.717C156.757 114.187 177.555 93.4308 203.137 93.4308C228.718 93.4308 249.516 114.187 249.516 139.717C249.516 165.247 228.718 186.004 203.137 186.004C177.555 186.004 156.757 165.455 156.757 139.717ZM203.137 52.1259C152.806 52.1259 111.834 93.0156 111.834 143.246C111.834 179.777 160.085 248.895 186.498 274.633C192.322 280.237 200.225 282.52 207.712 281.067C208.336 281.067 208.752 280.859 209.376 280.652C209.584 280.652 209.792 280.652 210 280.444C213.536 279.407 217.071 277.331 219.983 274.633C242.029 253.046 279.257 196.589 290.904 162.549C292.568 157.567 293.816 152.586 294.232 147.812C294.44 146.152 294.44 144.699 294.44 143.038C294.44 93.0156 253.676 52.1259 203.137 52.1259Z",
    fill: "#7647EE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M203.137 302.861C164.661 302.861 125.561 292.69 125.561 273.387C125.561 268.198 128.472 260.726 142.407 254.291C145.111 253.046 148.022 254.291 149.27 256.782C150.518 259.481 149.27 262.386 146.774 263.632C138.663 267.368 135.96 271.104 135.96 273.18C135.96 281.067 162.165 292.275 203.137 292.275C244.109 292.275 270.314 280.859 270.314 273.18C270.314 270.481 266.362 266.123 255.547 261.971C252.844 260.933 251.596 258.028 252.636 255.329C253.676 252.631 256.587 251.386 259.291 252.423C276.969 259.273 280.713 267.575 280.713 273.387C280.713 292.69 241.613 302.861 203.137 302.861Z",
    fill: "#15112D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1606_51365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.19 213.576C369.19 226.248 358.942 236.495 346.16 236.495C345.939 236.495 344.066 236.495 330.292 236.495C320.705 236.495 305.388 236.495 280.925 236.495H269.244C253.928 236.826 241.696 224.595 241.696 209.829C241.696 194.954 254.038 182.612 269.575 183.384C282.908 141.731 343.956 147.572 349.135 190.656C360.595 192.089 369.19 201.785 369.19 213.576Z",
    fill: "url(#paint6_linear_1606_51365)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M346.16 236.495C358.832 236.495 369.19 226.248 369.19 213.576C369.19 200.904 358.832 190.656 346.16 190.656C333.487 190.656 323.129 200.904 323.129 213.576C323.129 226.248 333.487 236.495 346.16 236.495Z",
    fill: "url(#paint7_linear_1606_51365)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M308.584 236.716C331.173 236.716 349.576 218.424 349.576 195.835C349.576 173.246 331.173 154.954 308.584 154.954C285.994 154.954 267.592 173.246 267.592 195.835C267.592 218.424 285.884 236.716 308.584 236.716Z",
    fill: "url(#paint8_linear_1606_51365)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1606_51365",
    x: 11.9592,
    y: 134.788,
    width: 171.494,
    height: 125.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1606_51365"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1606_51365",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1606_51365",
    x: 0,
    y: 0.22934,
    width: 219.883,
    height: 156.361,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1606_51365"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1606_51365",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1606_51365",
    x: 219.696,
    y: 144.054,
    width: 171.494,
    height: 125.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1606_51365"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1606_51365",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1606_51365",
    x1: 97.7063,
    y1: 179.445,
    x2: 97.6647,
    y2: 228.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1606_51365",
    x1: 112.942,
    y1: 176.456,
    x2: 133.357,
    y2: 198.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1606_51365",
    x1: 56.0162,
    y1: 167.81,
    x2: 88.1939,
    y2: 180.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1606_51365",
    x1: 109.942,
    y1: 57.6612,
    x2: 109.884,
    y2: 124.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1606_51365",
    x1: 130.959,
    y1: 53.5366,
    x2: 159.124,
    y2: 84.3407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1606_51365",
    x1: 52.4285,
    y1: 41.6096,
    x2: 96.8189,
    y2: 58.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1606_51365",
    x1: 305.443,
    y1: 188.711,
    x2: 305.402,
    y2: 237.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1606_51365",
    x1: 320.678,
    y1: 185.722,
    x2: 341.094,
    y2: 208.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1606_51365",
    x1: 263.753,
    y1: 177.076,
    x2: 295.931,
    y2: 189.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTablesEmptyState);
export default __webpack_public_path__ + "static/media/orderTablesEmptyState.77d07492e914592db15ca030109dabb8.svg";
export { ForwardRef as ReactComponent };